import { defineComponent as D, ref as F, toRef as E, computed as d, openBlock as O, createBlock as j, mergeProps as x, unref as n, createSlots as A, withCtx as i, renderSlot as l, normalizeProps as U, guardReactiveProps as q } from "vue";
import { useDynamicScroller as G } from "./composables/useDynamicScroller.js";
import { _ as H } from "./RecycleScroller.vue_vue_type_script_setup_true_lang-C7mZBLYi.js";
import "./scroller.css_vue_type_style_index_0_src_true_lang--7gJ3zh_.js";
const W = /* @__PURE__ */ D({
  inheritAttrs: !1,
  __name: "DynamicScroller",
  props: {
    items: {},
    keyField: { default: "id" },
    direction: { default: "vertical" },
    listTag: { default: "div" },
    itemTag: { default: "div" },
    minItemSize: {},
    shift: { type: Boolean, default: !1 },
    cache: { default: void 0 },
    disableTransform: { type: Boolean, default: !1 },
    flowMode: { type: Boolean, default: !1 },
    hiddenPosition: { default: void 0 },
    enabled: { type: Boolean, default: !0 },
    pageMode: { type: Boolean, default: !1 },
    scrollParent: { default: void 0 }
  },
  emits: ["resize", "visible"],
  setup(c, { expose: m, emit: f }) {
    const e = c, a = f, r = F(), p = E(e, "items"), u = d(() => {
      var t;
      const o = (t = r.value) == null ? void 0 : t.el;
      return o && typeof o == "object" && "value" in o ? o.value : o;
    }), h = d(() => ({
      items: p,
      keyField: e.keyField,
      direction: e.direction,
      minItemSize: e.minItemSize,
      shift: e.shift,
      cache: e.cache,
      flowMode: e.flowMode,
      hiddenPosition: e.hiddenPosition,
      enabled: e.enabled,
      pageMode: e.pageMode,
      scrollParent: e.scrollParent,
      el: u.value,
      onResize: () => a("resize"),
      onVisible: () => a("visible")
    })), b = G(
      h
    ), {
      itemsWithSize: g,
      forceUpdate: y,
      startSpacerSize: S,
      endSpacerSize: z,
      scrollToItem: v,
      scrollToPosition: P,
      findItemIndex: k,
      getItemOffset: B,
      getItemSize: I,
      cacheSnapshot: T,
      restoreCache: M,
      scrollToBottom: $,
      onScrollerResize: w,
      onScrollerVisible: R
    } = b;
    function _(o, t, s) {
      return {
        item: o.item,
        index: t,
        active: s,
        itemWithSize: o
      };
    }
    return m({
      startSpacerSize: S,
      endSpacerSize: z,
      scrollToItem: v,
      scrollToPosition: P,
      findItemIndex: k,
      getItemOffset: B,
      scrollToBottom: $,
      getItemSize: I,
      cacheSnapshot: T,
      restoreCache: M,
      forceUpdate: y
    }), (o, t) => (O(), j(H, x({
      ref_key: "scroller",
      ref: r,
      items: n(g),
      "min-item-size": e.minItemSize,
      direction: e.direction,
      cache: e.cache,
      "disable-transform": e.disableTransform,
      "flow-mode": e.flowMode,
      "hidden-position": e.hiddenPosition,
      enabled: e.enabled,
      "page-mode": e.pageMode,
      "scroll-parent": e.scrollParent,
      "key-field": "id",
      "list-tag": e.listTag,
      "item-tag": e.itemTag
    }, o.$attrs, {
      onResize: n(w),
      onVisible: n(R)
    }), A({
      default: i(({ item: s, index: V, active: C }) => [
        l(o.$slots, "default", U(q(_(s, V, C))))
      ]),
      empty: i(() => [
        l(o.$slots, "empty")
      ]),
      _: 2
    }, [
      o.$slots.before ? {
        name: "before",
        fn: i(() => [
          l(o.$slots, "before")
        ]),
        key: "0"
      } : void 0,
      o.$slots.after ? {
        name: "after",
        fn: i(() => [
          l(o.$slots, "after")
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["items", "min-item-size", "direction", "cache", "disable-transform", "flow-mode", "hidden-position", "enabled", "page-mode", "scroll-parent", "list-tag", "item-tag", "onResize", "onVisible"]));
  }
});
export {
  W as _
};
//# sourceMappingURL=DynamicScroller.vue_vue_type_script_setup_true_lang-yssX6Q5B.js.map
